import HttpService from './httpService';
import config from '../../config';

class AlumnosApiService extends HttpService {
  async buscarAlumnos({ empresaId, email }, { auth }) {
    return this.get('buscarAlumnos', {
      headers: {
        Authorization: `Bearer ${auth}`,
      },
      params: {
        empresaId,
        email,
        userEmail: email,
      },
    });
  }

  async cargarAlumno({ id, headquarter, idCedesca, idCntec }) {
    return this.get('cargarAlumno', { params: { id, headquarter, idCedesca, idCntec } });
  }

  async cargarFacturasPortal({ idAlumno, headquarter }) {
    return this.get('cargarFacturasPortal', { params: { idAlumno, headquarter } });
  }

  async crearFacturaPortalPDF(headquarter, id, email, emailName, idFactura) {
    const reqConfig = {
      params: { headquarter, id, email, emailName, idFactura },
    };

    if (email) {
      reqConfig.responseType = 'blob';
    }

    return this.get('crearFacturaPortalPDF', reqConfig);
  }
}

const alumnosApiService = new AlumnosApiService(config.REACT_APP_NODE_API);
export default alumnosApiService;
